import * as _dayjs2 from "dayjs";
var _dayjs = "default" in _dayjs2 ? _dayjs2.default : _dayjs2;
import { dew as _AbstractParserWithWordBoundaryDew } from "../../../../common/parsers/AbstractParserWithWordBoundary";
import { dew as _constantsDew } from "../constants";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  var __importDefault = exports && exports.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  const dayjs_1 = __importDefault(_dayjs);
  const AbstractParserWithWordBoundary_1 = _AbstractParserWithWordBoundaryDew();
  const constants_1 = _constantsDew();
  const FIRST_REG_PATTERN = new RegExp("(?:\u4ECE|\u81EA)?" + "(?:" + "(\u4ECA|\u660E|\u524D|\u5927\u524D|\u540E|\u5927\u540E|\u6628)(\u65E9|\u671D|\u665A)|" + "(\u4E0A(?:\u5348)|\u65E9(?:\u4E0A)|\u4E0B(?:\u5348)|\u665A(?:\u4E0A)|\u591C(?:\u665A)?|\u4E2D(?:\u5348)|\u51CC(?:\u6668))|" + "(\u4ECA|\u660E|\u524D|\u5927\u524D|\u540E|\u5927\u540E|\u6628)(?:\u65E5|\u5929)" + "(?:[\\s,\uFF0C]*)" + "(?:(\u4E0A(?:\u5348)|\u65E9(?:\u4E0A)|\u4E0B(?:\u5348)|\u665A(?:\u4E0A)|\u591C(?:\u665A)?|\u4E2D(?:\u5348)|\u51CC(?:\u6668)))?" + ")?" + "(?:[\\s,\uFF0C]*)" + "(?:(\\d+|[" + Object.keys(constants_1.NUMBER).join("") + "]+)(?:\\s*)(?:\u70B9|\u65F6|:|\uFF1A)" + "(?:\\s*)" + "(\\d+|\u534A|\u6B63|\u6574|[" + Object.keys(constants_1.NUMBER).join("") + "]+)?(?:\\s*)(?:\u5206|:|\uFF1A)?" + "(?:\\s*)" + "(\\d+|[" + Object.keys(constants_1.NUMBER).join("") + "]+)?(?:\\s*)(?:\u79D2)?)" + "(?:\\s*(A.M.|P.M.|AM?|PM?))?", "i");
  const SECOND_REG_PATTERN = new RegExp("(?:^\\s*(?:\u5230|\u81F3|\\-|\\\u2013|\\~|\\\u301C)\\s*)" + "(?:" + "(\u4ECA|\u660E|\u524D|\u5927\u524D|\u540E|\u5927\u540E|\u6628)(\u65E9|\u671D|\u665A)|" + "(\u4E0A(?:\u5348)|\u65E9(?:\u4E0A)|\u4E0B(?:\u5348)|\u665A(?:\u4E0A)|\u591C(?:\u665A)?|\u4E2D(?:\u5348)|\u51CC(?:\u6668))|" + "(\u4ECA|\u660E|\u524D|\u5927\u524D|\u540E|\u5927\u540E|\u6628)(?:\u65E5|\u5929)" + "(?:[\\s,\uFF0C]*)" + "(?:(\u4E0A(?:\u5348)|\u65E9(?:\u4E0A)|\u4E0B(?:\u5348)|\u665A(?:\u4E0A)|\u591C(?:\u665A)?|\u4E2D(?:\u5348)|\u51CC(?:\u6668)))?" + ")?" + "(?:[\\s,\uFF0C]*)" + "(?:(\\d+|[" + Object.keys(constants_1.NUMBER).join("") + "]+)(?:\\s*)(?:\u70B9|\u65F6|:|\uFF1A)" + "(?:\\s*)" + "(\\d+|\u534A|\u6B63|\u6574|[" + Object.keys(constants_1.NUMBER).join("") + "]+)?(?:\\s*)(?:\u5206|:|\uFF1A)?" + "(?:\\s*)" + "(\\d+|[" + Object.keys(constants_1.NUMBER).join("") + "]+)?(?:\\s*)(?:\u79D2)?)" + "(?:\\s*(A.M.|P.M.|AM?|PM?))?", "i");
  const DAY_GROUP_1 = 1;
  const ZH_AM_PM_HOUR_GROUP_1 = 2;
  const ZH_AM_PM_HOUR_GROUP_2 = 3;
  const DAY_GROUP_3 = 4;
  const ZH_AM_PM_HOUR_GROUP_3 = 5;
  const HOUR_GROUP = 6;
  const MINUTE_GROUP = 7;
  const SECOND_GROUP = 8;
  const AM_PM_HOUR_GROUP = 9;
  class ZHHansTimeExpressionParser extends AbstractParserWithWordBoundary_1.AbstractParserWithWordBoundaryChecking {
    innerPattern() {
      return FIRST_REG_PATTERN;
    }
    innerExtract(context, match) {
      if (match.index > 0 && context.text[match.index - 1].match(/\w/)) {
        return null;
      }
      const refMoment = dayjs_1.default(context.refDate);
      const result = context.createParsingResult(match.index, match[0]);
      let startMoment = refMoment.clone();
      if (match[DAY_GROUP_1]) {
        const day1 = match[DAY_GROUP_1];
        if (day1 == "\u660E") {
          if (refMoment.hour() > 1) {
            startMoment = startMoment.add(1, "day");
          }
        } else if (day1 == "\u6628") {
          startMoment = startMoment.add(-1, "day");
        } else if (day1 == "\u524D") {
          startMoment = startMoment.add(-2, "day");
        } else if (day1 == "\u5927\u524D") {
          startMoment = startMoment.add(-3, "day");
        } else if (day1 == "\u540E") {
          startMoment = startMoment.add(2, "day");
        } else if (day1 == "\u5927\u540E") {
          startMoment = startMoment.add(3, "day");
        }
        result.start.assign("day", startMoment.date());
        result.start.assign("month", startMoment.month() + 1);
        result.start.assign("year", startMoment.year());
      } else if (match[DAY_GROUP_3]) {
        const day3 = match[DAY_GROUP_3];
        if (day3 == "\u660E") {
          startMoment = startMoment.add(1, "day");
        } else if (day3 == "\u6628") {
          startMoment = startMoment.add(-1, "day");
        } else if (day3 == "\u524D") {
          startMoment = startMoment.add(-2, "day");
        } else if (day3 == "\u5927\u524D") {
          startMoment = startMoment.add(-3, "day");
        } else if (day3 == "\u540E") {
          startMoment = startMoment.add(2, "day");
        } else if (day3 == "\u5927\u540E") {
          startMoment = startMoment.add(3, "day");
        }
        result.start.assign("day", startMoment.date());
        result.start.assign("month", startMoment.month() + 1);
        result.start.assign("year", startMoment.year());
      } else {
        result.start.imply("day", startMoment.date());
        result.start.imply("month", startMoment.month() + 1);
        result.start.imply("year", startMoment.year());
      }
      let hour = 0;
      let minute = 0;
      let meridiem = -1;
      if (match[SECOND_GROUP]) {
        let second = parseInt(match[SECOND_GROUP]);
        if (isNaN(second)) {
          second = constants_1.zhStringToNumber(match[SECOND_GROUP]);
        }
        if (second >= 60) return null;
        result.start.assign("second", second);
      }
      hour = parseInt(match[HOUR_GROUP]);
      if (isNaN(hour)) {
        hour = constants_1.zhStringToNumber(match[HOUR_GROUP]);
      }
      if (match[MINUTE_GROUP]) {
        if (match[MINUTE_GROUP] == "\u534A") {
          minute = 30;
        } else if (match[MINUTE_GROUP] == "\u6B63" || match[MINUTE_GROUP] == "\u6574") {
          minute = 0;
        } else {
          minute = parseInt(match[MINUTE_GROUP]);
          if (isNaN(minute)) {
            minute = constants_1.zhStringToNumber(match[MINUTE_GROUP]);
          }
        }
      } else if (hour > 100) {
        minute = hour % 100;
        hour = Math.floor(hour / 100);
      }
      if (minute >= 60) {
        return null;
      }
      if (hour > 24) {
        return null;
      }
      if (hour >= 12) {
        meridiem = 1;
      }
      if (match[AM_PM_HOUR_GROUP]) {
        if (hour > 12) return null;
        const ampm = match[AM_PM_HOUR_GROUP][0].toLowerCase();
        if (ampm == "a") {
          meridiem = 0;
          if (hour == 12) hour = 0;
        }
        if (ampm == "p") {
          meridiem = 1;
          if (hour != 12) hour += 12;
        }
      } else if (match[ZH_AM_PM_HOUR_GROUP_1]) {
        const zhAMPMString1 = match[ZH_AM_PM_HOUR_GROUP_1];
        const zhAMPM1 = zhAMPMString1[0];
        if (zhAMPM1 == "\u65E9") {
          meridiem = 0;
          if (hour == 12) hour = 0;
        } else if (zhAMPM1 == "\u665A") {
          meridiem = 1;
          if (hour != 12) hour += 12;
        }
      } else if (match[ZH_AM_PM_HOUR_GROUP_2]) {
        const zhAMPMString2 = match[ZH_AM_PM_HOUR_GROUP_2];
        const zhAMPM2 = zhAMPMString2[0];
        if (zhAMPM2 == "\u4E0A" || zhAMPM2 == "\u65E9" || zhAMPM2 == "\u51CC") {
          meridiem = 0;
          if (hour == 12) hour = 0;
        } else if (zhAMPM2 == "\u4E0B" || zhAMPM2 == "\u665A") {
          meridiem = 1;
          if (hour != 12) hour += 12;
        }
      } else if (match[ZH_AM_PM_HOUR_GROUP_3]) {
        const zhAMPMString3 = match[ZH_AM_PM_HOUR_GROUP_3];
        const zhAMPM3 = zhAMPMString3[0];
        if (zhAMPM3 == "\u4E0A" || zhAMPM3 == "\u65E9" || zhAMPM3 == "\u51CC") {
          meridiem = 0;
          if (hour == 12) hour = 0;
        } else if (zhAMPM3 == "\u4E0B" || zhAMPM3 == "\u665A") {
          meridiem = 1;
          if (hour != 12) hour += 12;
        }
      }
      result.start.assign("hour", hour);
      result.start.assign("minute", minute);
      if (meridiem >= 0) {
        result.start.assign("meridiem", meridiem);
      } else {
        if (hour < 12) {
          result.start.imply("meridiem", 0);
        } else {
          result.start.imply("meridiem", 1);
        }
      }
      match = SECOND_REG_PATTERN.exec(context.text.substring(result.index + result.text.length));
      if (!match) {
        if (result.text.match(/^\d+$/)) {
          return null;
        }
        return result;
      }
      let endMoment = startMoment.clone();
      result.end = context.createParsingComponents();
      if (match[DAY_GROUP_1]) {
        const day1 = match[DAY_GROUP_1];
        if (day1 == "\u660E") {
          if (refMoment.hour() > 1) {
            endMoment = endMoment.add(1, "day");
          }
        } else if (day1 == "\u6628") {
          endMoment = endMoment.add(-1, "day");
        } else if (day1 == "\u524D") {
          endMoment = endMoment.add(-2, "day");
        } else if (day1 == "\u5927\u524D") {
          endMoment = endMoment.add(-3, "day");
        } else if (day1 == "\u540E") {
          endMoment = endMoment.add(2, "day");
        } else if (day1 == "\u5927\u540E") {
          endMoment = endMoment.add(3, "day");
        }
        result.end.assign("day", endMoment.date());
        result.end.assign("month", endMoment.month() + 1);
        result.end.assign("year", endMoment.year());
      } else if (match[DAY_GROUP_3]) {
        const day3 = match[DAY_GROUP_3];
        if (day3 == "\u660E") {
          endMoment = endMoment.add(1, "day");
        } else if (day3 == "\u6628") {
          endMoment = endMoment.add(-1, "day");
        } else if (day3 == "\u524D") {
          endMoment = endMoment.add(-2, "day");
        } else if (day3 == "\u5927\u524D") {
          endMoment = endMoment.add(-3, "day");
        } else if (day3 == "\u540E") {
          endMoment = endMoment.add(2, "day");
        } else if (day3 == "\u5927\u540E") {
          endMoment = endMoment.add(3, "day");
        }
        result.end.assign("day", endMoment.date());
        result.end.assign("month", endMoment.month() + 1);
        result.end.assign("year", endMoment.year());
      } else {
        result.end.imply("day", endMoment.date());
        result.end.imply("month", endMoment.month() + 1);
        result.end.imply("year", endMoment.year());
      }
      hour = 0;
      minute = 0;
      meridiem = -1;
      if (match[SECOND_GROUP]) {
        let second = parseInt(match[SECOND_GROUP]);
        if (isNaN(second)) {
          second = constants_1.zhStringToNumber(match[SECOND_GROUP]);
        }
        if (second >= 60) return null;
        result.end.assign("second", second);
      }
      hour = parseInt(match[HOUR_GROUP]);
      if (isNaN(hour)) {
        hour = constants_1.zhStringToNumber(match[HOUR_GROUP]);
      }
      if (match[MINUTE_GROUP]) {
        if (match[MINUTE_GROUP] == "\u534A") {
          minute = 30;
        } else if (match[MINUTE_GROUP] == "\u6B63" || match[MINUTE_GROUP] == "\u6574") {
          minute = 0;
        } else {
          minute = parseInt(match[MINUTE_GROUP]);
          if (isNaN(minute)) {
            minute = constants_1.zhStringToNumber(match[MINUTE_GROUP]);
          }
        }
      } else if (hour > 100) {
        minute = hour % 100;
        hour = Math.floor(hour / 100);
      }
      if (minute >= 60) {
        return null;
      }
      if (hour > 24) {
        return null;
      }
      if (hour >= 12) {
        meridiem = 1;
      }
      if (match[AM_PM_HOUR_GROUP]) {
        if (hour > 12) return null;
        const ampm = match[AM_PM_HOUR_GROUP][0].toLowerCase();
        if (ampm == "a") {
          meridiem = 0;
          if (hour == 12) hour = 0;
        }
        if (ampm == "p") {
          meridiem = 1;
          if (hour != 12) hour += 12;
        }
        if (!result.start.isCertain("meridiem")) {
          if (meridiem == 0) {
            result.start.imply("meridiem", 0);
            if (result.start.get("hour") == 12) {
              result.start.assign("hour", 0);
            }
          } else {
            result.start.imply("meridiem", 1);
            if (result.start.get("hour") != 12) {
              result.start.assign("hour", result.start.get("hour") + 12);
            }
          }
        }
      } else if (match[ZH_AM_PM_HOUR_GROUP_1]) {
        const zhAMPMString1 = match[ZH_AM_PM_HOUR_GROUP_1];
        const zhAMPM1 = zhAMPMString1[0];
        if (zhAMPM1 == "\u65E9") {
          meridiem = 0;
          if (hour == 12) hour = 0;
        } else if (zhAMPM1 == "\u665A") {
          meridiem = 1;
          if (hour != 12) hour += 12;
        }
      } else if (match[ZH_AM_PM_HOUR_GROUP_2]) {
        const zhAMPMString2 = match[ZH_AM_PM_HOUR_GROUP_2];
        const zhAMPM2 = zhAMPMString2[0];
        if (zhAMPM2 == "\u4E0A" || zhAMPM2 == "\u65E9" || zhAMPM2 == "\u51CC") {
          meridiem = 0;
          if (hour == 12) hour = 0;
        } else if (zhAMPM2 == "\u4E0B" || zhAMPM2 == "\u665A") {
          meridiem = 1;
          if (hour != 12) hour += 12;
        }
      } else if (match[ZH_AM_PM_HOUR_GROUP_3]) {
        const zhAMPMString3 = match[ZH_AM_PM_HOUR_GROUP_3];
        const zhAMPM3 = zhAMPMString3[0];
        if (zhAMPM3 == "\u4E0A" || zhAMPM3 == "\u65E9" || zhAMPM3 == "\u51CC") {
          meridiem = 0;
          if (hour == 12) hour = 0;
        } else if (zhAMPM3 == "\u4E0B" || zhAMPM3 == "\u665A") {
          meridiem = 1;
          if (hour != 12) hour += 12;
        }
      }
      result.text = result.text + match[0];
      result.end.assign("hour", hour);
      result.end.assign("minute", minute);
      if (meridiem >= 0) {
        result.end.assign("meridiem", meridiem);
      } else {
        const startAtPM = result.start.isCertain("meridiem") && result.start.get("meridiem") == 1;
        if (startAtPM && result.start.get("hour") > hour) {
          result.end.imply("meridiem", 0);
        } else if (hour > 12) {
          result.end.imply("meridiem", 1);
        }
      }
      if (result.end.date().getTime() < result.start.date().getTime()) {
        result.end.imply("day", result.end.get("day") + 1);
      }
      return result;
    }
  }
  exports.default = ZHHansTimeExpressionParser;
  //# sourceMappingURL=ZHHansTimeExpressionParser.js.map
  return exports;
}